import WsTheme from './WsTheme';

export default WsTheme;
